import React from 'react';
import TwoFactorSettings from '../../../../features/two-factor-auth/components/TwoFactorSettings';
import PrivacySettings from '../PrivacySettings';

const AccountSettingsSecurity = ({
  user,
  canViewPrivacySettings,
  resendCooldownSeconds,
  resendLoading,
  onResendVerification,
  onUserUpdate,
}) => (
  <div className="asSecurityBlock">
    <div className="asSecurityGroup">
      <div className="asSettingRow">
        <div className="asSettingRow__content">
          <span className="asSettingRow__title">Email verification</span>
          <span className="asSettingRow__desc">
            {user.emailVerified
              ? 'Your email address is confirmed.'
              : 'Verify your email to secure your account.'}
          </span>
        </div>
        <div className="asSettingRow__control">
          {user.emailVerified ? (
            <span className={`asVerifyBadge ${user.emailVerified ? 'verified' : 'unverified'}`}>
              Verified
            </span>
          ) : (
            <button
              type="button"
              className="asResendVerifyBtn"
              onClick={onResendVerification}
              disabled={resendLoading || resendCooldownSeconds > 0}
            >
              {resendCooldownSeconds > 0
                ? `Resend in ${resendCooldownSeconds}s`
                : resendLoading
                  ? 'Sending…'
                  : 'Resend email'}
            </button>
          )}
        </div>
      </div>
    </div>

    <div className="asSecurityGroup">
      <h3 className="asSecurityGroupTitle">Two-factor authentication</h3>
      <TwoFactorSettings
        variant="embedded"
        user={user}
        onUserUpdate={onUserUpdate}
      />
    </div>

    {canViewPrivacySettings && (
      <div className="asSecurityGroup">
        <h3 className="asSecurityGroupTitle">Support access</h3>
        <PrivacySettings variant="embedded" />
      </div>
    )}
  </div>
);

export default AccountSettingsSecurity;
